/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UserCryptoAddress,
  UtxUserCryptoAddressFindAllWalletAddressesParams,
  CreateUserCryptoAddressDTO,
  EditUserCryptoAddressDTO
} from './schema'



export const utxUserCryptoAddressFindAllWalletAddresses = (
    params: UtxUserCryptoAddressFindAllWalletAddressesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserCryptoAddress[]>> => {
    return axios.get(
      `/user-crypto-address`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxUserCryptoAddressFindAllWalletAddressesQueryKey = (params: UtxUserCryptoAddressFindAllWalletAddressesParams,) => [`/user-crypto-address`, ...(params ? [params]: [])];

    
export type UtxUserCryptoAddressFindAllWalletAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof utxUserCryptoAddressFindAllWalletAddresses>>>
export type UtxUserCryptoAddressFindAllWalletAddressesQueryError = AxiosError<void>

export const useUtxUserCryptoAddressFindAllWalletAddresses = <TData = Awaited<ReturnType<typeof utxUserCryptoAddressFindAllWalletAddresses>>, TError = AxiosError<void>>(
 params: UtxUserCryptoAddressFindAllWalletAddressesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUserCryptoAddressFindAllWalletAddresses>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUserCryptoAddressFindAllWalletAddressesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUserCryptoAddressFindAllWalletAddresses>>> = ({ signal }) => utxUserCryptoAddressFindAllWalletAddresses(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUserCryptoAddressFindAllWalletAddresses>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxUserCryptoAddressCreateNewWalletAddress = (
    createUserCryptoAddressDTO: CreateUserCryptoAddressDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserCryptoAddress[]>> => {
    return axios.post(
      `/user-crypto-address/new`,
      createUserCryptoAddressDTO,options
    );
  }



    export type UtxUserCryptoAddressCreateNewWalletAddressMutationResult = NonNullable<Awaited<ReturnType<typeof utxUserCryptoAddressCreateNewWalletAddress>>>
    export type UtxUserCryptoAddressCreateNewWalletAddressMutationBody = CreateUserCryptoAddressDTO
    export type UtxUserCryptoAddressCreateNewWalletAddressMutationError = AxiosError<void>

    export const useUtxUserCryptoAddressCreateNewWalletAddress = <TError = AxiosError<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUserCryptoAddressCreateNewWalletAddress>>, TError,{data: CreateUserCryptoAddressDTO}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUserCryptoAddressCreateNewWalletAddress>>, {data: CreateUserCryptoAddressDTO}> = (props) => {
          const {data} = props ?? {};

          return  utxUserCryptoAddressCreateNewWalletAddress(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUserCryptoAddressCreateNewWalletAddress>>, TError, {data: CreateUserCryptoAddressDTO}, TContext>(mutationFn, mutationOptions)
    }
    export const utxUserCryptoAddressUpdateCryptoAddress = (
    id: string,
    editUserCryptoAddressDTO: EditUserCryptoAddressDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserCryptoAddress>> => {
    return axios.patch(
      `/user-crypto-address/${id}`,
      editUserCryptoAddressDTO,options
    );
  }



    export type UtxUserCryptoAddressUpdateCryptoAddressMutationResult = NonNullable<Awaited<ReturnType<typeof utxUserCryptoAddressUpdateCryptoAddress>>>
    export type UtxUserCryptoAddressUpdateCryptoAddressMutationBody = EditUserCryptoAddressDTO
    export type UtxUserCryptoAddressUpdateCryptoAddressMutationError = AxiosError<void>

    export const useUtxUserCryptoAddressUpdateCryptoAddress = <TError = AxiosError<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUserCryptoAddressUpdateCryptoAddress>>, TError,{id: string;data: EditUserCryptoAddressDTO}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUserCryptoAddressUpdateCryptoAddress>>, {id: string;data: EditUserCryptoAddressDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  utxUserCryptoAddressUpdateCryptoAddress(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUserCryptoAddressUpdateCryptoAddress>>, TError, {id: string;data: EditUserCryptoAddressDTO}, TContext>(mutationFn, mutationOptions)
    }
    export const utxUserCryptoAddressDeleteUserCryptoAddress = (
    id: unknown, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.delete(
      `/user-crypto-address/${id}`,options
    );
  }



    export type UtxUserCryptoAddressDeleteUserCryptoAddressMutationResult = NonNullable<Awaited<ReturnType<typeof utxUserCryptoAddressDeleteUserCryptoAddress>>>
    
    export type UtxUserCryptoAddressDeleteUserCryptoAddressMutationError = AxiosError<unknown>

    export const useUtxUserCryptoAddressDeleteUserCryptoAddress = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUserCryptoAddressDeleteUserCryptoAddress>>, TError,{id: unknown}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUserCryptoAddressDeleteUserCryptoAddress>>, {id: unknown}> = (props) => {
          const {id} = props ?? {};

          return  utxUserCryptoAddressDeleteUserCryptoAddress(id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUserCryptoAddressDeleteUserCryptoAddress>>, TError, {id: unknown}, TContext>(mutationFn, mutationOptions)
    }
    